import { createSelector } from 'reselect';
import {
  getArmyListUnits,
  getOrganisations,
  getUnits,
} from '../make/unit/edit/selector/editSelector';
import { ArmyListUnitView } from '../make/view/ArmyListUnitView';

export const armyListUnits = createSelector(
  [getUnits, getArmyListUnits, getOrganisations],
  (units, armyListUnits, organisations): Array<ArmyListUnitView> => {
    return [...armyListUnits]
      .sort((a, b) => a.position - b.position)
      .map((item) => {
        const unit = units.find((u) => u.id === item.unit_id);
        const organisation = organisations.find(
          (o) => o.id === item.organisation_id,
        );

        return new ArmyListUnitView({
          id: item.id,
          item: item,
          index: ('0' + item.position).slice(-2),
          position: item.position,
          name: item.name,
          points: item.points,
          isEnabled: item.is_enabled,
          size: item.size,
          unitName: unit?.name ?? null,
          unitId: item.unit_id,
          organisationName: organisation?.name ?? null,
        });
      });
  },
);
